module.exports = __webpack_public_path__ + "img/paperclip.99642abe.svg";